import { render } from "./color-picker.vue?vue&type=template&id=d910cdf0&ts=true"
import script from "./color-picker.vue?vue&type=script&lang=ts"
export * from "./color-picker.vue?vue&type=script&lang=ts"

import "./color-picker.vue?vue&type=style&index=0&id=d910cdf0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__